export const FIELDS = {

  ID: 'id',
  INVOICE_ID: 'invoiceId',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  WORK_ORDER_ID: 'workOrderId',
  EXPENSE_ID: 'expenseId',
  DESCRIPTION: 'description',
  AMOUNT: 'amount',
  QBTXN_ID: 'qbTxnId',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  PAYMENT_ID: 'paymentId',
  EXPENSE_ACCOUNT_ID: 'expenseAccountId',
  EXPENSE_ACCOUNT_NAME: 'expenseAccountName',
  EXPENSE_DATE: 'expenseDate',
  CREATED_BY_USER_NAME: 'createdByUserName',
  MODIFIE_BY_USER_NAME: 'modifieByUserName',
};